<script>
export default {
    name: 'IntervalMixin',
    data() {
        return {
            mixinUpdated: new Date().valueOf(), // 上次刷新时间
            mixinUpdatedInterval: 5000, // 自动刷新间隔时间
            mixinOnlyTradingTime: true, // 是否只在交易时间运行 9：30 ~ 11：30， 13：00 ~ 15：00
            mixinIntervalRunning: true, // interval 递归状态标记
        };
    },
    created() {
        this.mixinInterval();
    },
    destroyed() {
        console.log('destroyed');
        this.mixinUpdated = null;
    },
    methods: {
        mixinInterval() {
            if (!this.mixinUpdated) {
                this.mixinIntervalRunning = false;
                return;
            }
            const now = new Date().valueOf();
            let shoudUpdate = true;
            if (this.mixinOnlyTradingTime) {
                const hour =
                    (now % (1000 * 60 * 60 * 24)) / (60 * 60 * 1000) + 8;
                shoudUpdate =
                    (hour >= 9.5 && hour < 11.5) || (hour >= 13 && hour < 15);
            }

            if (
                shoudUpdate &&
                now - this.mixinUpdated > this.mixinUpdatedInterval
            ) {
                this.mixinUpdated = now;
                this.mixinIntervalMethods();
            }

            const self = this;
            this.mixinIntervalRunning = true;
            window.requestAnimationFrame(() => {
                self.mixinInterval();
            });
        },
        mixinIntervalMethods() {
            // Rewrite interval methods
        },
    },
};
</script>
